import { invokeApi } from "../bl_libs/invokeApi";

export const add_company_api = async (data) => {
  const requestObj = {
    path: `api/company/add`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_companies_api = async (data) => {
  const requestObj = {
    path: `api/company/list`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_company_detail_api = async (company_id) => {
  const requestObj = {
    path: `api/company/detail/${company_id}`,
    method: "GET",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};

export const get_company_delete_api = async (company_id) => {
  const requestObj = {
    path: `api/company/delete/${company_id}`,
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};